import { graphql, useLazyLoadQuery } from "react-relay"
import { useTreamentByIdQuery } from "@/modules/admin/treatment/services/__generated__/useTreamentByIdQuery.graphql"

export const treatmentByIdQuery = graphql`
  query useTreamentByIdQuery($id: ID!, $skip: Boolean!) {
    treatmentPlanTemplateById(id: $id) @skip(if: $skip) {
      id
      countries
      name
      languages {
        language
        title
        synonym
        followUpInstructions
        recommendedTreatment
      }
      icdDiagnoses {
        id
        diagnosisCode
        text
      }
    }
  }
`

const useGetTreamentPlanTemplateByIdQuery = (id: string, skip = false) => {
  const data = useLazyLoadQuery<useTreamentByIdQuery>(treatmentByIdQuery, {
    id,
    skip,
  })

  return data
}

export { useGetTreamentPlanTemplateByIdQuery }
